import { SET_QUERIES_TO_STORE } from 'actions/index'
import trans from "trans"
import _map from "lodash/map"
import { ReduxList, Action } from "app/types/app-types"
import { Query } from "app/types/model-types"

export type Queries = ReduxList<Query>
const defaultQueriesState: Queries = {
    data: [],
    error: null,
    isLoaded: false,
    isLoading: false,
    updated: null,
}


/**
 * Queries Reducer.
 *
 * @param state
 * @param action
 */
export default function (state: Queries = defaultQueriesState, action: Action<Queries>): Queries {
    switch (action.type) {
        case SET_QUERIES_TO_STORE:
            let data = _map(action.payload, (query: any) => {
                if (query.name === "bf.all_products") {
                    query.name = trans("all_products")
                }
                return query
            })

            return {...state, ...{data, isLoaded: true, isLoading: false, updated: new Date()} }
        default:
            return state
    }
}
